import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

import { getWorkerBookabilityPreferenceUrl } from "./utils";

const attributesSchema = z.object({
  workerId: z.string(),
  autoBookingIsEnabled: z.boolean(),
  distanceInMiles: z.number(),
});

const responseSchema = z.object({
  data: z.union([
    z.object({
      attributes: attributesSchema,
      id: z.string(),
      type: z.string(),
    }),
    z.object({}).strict(),
  ]),
});

export type GetWorkerBookabilityPreferenceResponse = z.infer<typeof responseSchema>;

export function useGetWorkerBookabilityPreference(
  params: { workerId?: string },
  options: UseGetQueryOptions<GetWorkerBookabilityPreferenceResponse> = {}
): UseQueryResult<GetWorkerBookabilityPreferenceResponse> {
  return useGetQuery({
    url: getWorkerBookabilityPreferenceUrl(params.workerId ?? ""),
    responseSchema,
    meta: {
      userErrorMessage: "Something went wrong while fetching your bookability preferences",
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_BOOKABILITY_PREFERENCE_API_FAILURE,
    },
    enabled: isDefined(params.workerId),
    ...options,
  });
}
